module.exports = __webpack_public_path__ + "img/arrow-down-black.ff65dca7.svg";